module.exports = __webpack_public_path__ + "img/icon_symbol_color.802210e9.svg";